module.exports = __webpack_public_path__ + "img/asset_FTT.ae13b098.svg";